export default __webpack_public_path__ + "static/media/assista.b7c90168.svg";